import { Input } from '@nextui-org/react';
import { useTranslation } from 'react-i18next';

const LABEL_CLASS = 'text-[#414651] font-[Poppins] font-medium text-sm leading-[20px] tracking-normal';

export interface WebAgentConfigurationProps {
  readonly startUrl: string;
  readonly onChange: (startUrl: string) => void;
  readonly isReadOnly?: boolean;
}

export function WebAgentConfiguration({ startUrl, onChange, isReadOnly }: WebAgentConfigurationProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <label htmlFor="web_agent_start_url">
          <span className={LABEL_CLASS}>{t('Start URL')}<span className="text-danger">*</span></span>
        </label>
        <Input id="web_agent_start_url" type="url" size="sm" aria-label="web_agent_start_url" placeholder="https://…" value={startUrl} isRequired isReadOnly={isReadOnly} onValueChange={onChange} />
        <span className="text-xs text-default-400">{t('Available in steps tab in configuration as ${startUrl}.')}</span>
      </div>
    </div>
  );
}

export default WebAgentConfiguration;
